import {useState} from "react";
import NavBar from "./component/NavBar/NavBar";
import {Route, Routes} from "react-router-dom";
import NewsCategories from "./pages/NewsCategories/NewsCategories";
import ReporterSideBar from "./component/ReporterSideBar/ReporterSideBar";
import AddNewsCategories from "./pages/NewsCategories/AddNewsCategories/AddNewsCategories";
import UpdateNewsCategories from "./pages/NewsCategories/UpdateNewsCategories/UpdateNewsCategories";
import News from "./pages/News/News";
import AddNews from "./pages/News/AddNews/AddNews";
import UpdateNews from "./pages/News/UpdateNews/UpdateNews";
import NewsComments from "./pages/NewsComments/NewsComments";

const ReporterContent = () => {
    const [collapsed, setCollapsed] = useState(false);
    return (
        <div className="wrapper">
            <ReporterSideBar collapsed={collapsed}/>

            <div className="main">
                <NavBar setCollapsed={() => setCollapsed(!collapsed)}/>

                <main className="content">
                    <Routes>

                        <Route path="newsCategories" element={<NewsCategories/>}/>
                        <Route path="newsCategories/add" element={<AddNewsCategories/>}/>
                        <Route path="newsCategories/update/:id" element={<UpdateNewsCategories/>}/>

                        <Route path="news" element={<News/>}/>
                        <Route path="news/add" element={<AddNews/>}/>
                        <Route path="news/update/:id" element={<UpdateNews/>}/>

                        <Route path="comments" element={<NewsComments/>}/>

                    </Routes>

                </main>

                <footer className="footer">
                    <div className="container-fluid">
                        <div className="row text-muted">
                            <div className="col-6 text-start">
                                <p className="mb-0">
                                    <a className="text-muted" href="https://adminkit.io/"
                                       target="_blank"><strong>AdminKit</strong></a> - <a className="text-muted"
                                                                                          href="https://adminkit.io/"
                                                                                          target="_blank"><strong>Bootstrap
                                    Admin Template</strong></a>                                &copy;
                                </p>
                            </div>
                            <div className="col-6 text-end">
                                <ul className="list-inline">
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/"
                                           target="_blank">Support</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/" target="_blank">Help
                                            Center</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/"
                                           target="_blank">Privacy</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/" target="_blank">Terms</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>

        </div>
    );
}

export default ReporterContent;